import React, { useState } from 'react';
import { injectIntl } from 'react-intl';
import { i18nIntl, isNotEmpty } from '../../../lib/ep.js';

import ActionLink from '../../builder/ActionLink';
import DateWithSelector from '../../builder/DateWithSelector';
import LeveledHTMLText from '../helpers/LeveledHTMLText.js';
import FloatingLayerPublic from '../FloatingLayerPublic.js';

const Wrapper = (props) => {
	return (
		<FloatingLayerPublic
			pm={props.promotion}
			is_builder={props?.is_builder ?? false}
			enable_close={false}
		>
			<div id="age_restriction" class="mod_align_center">
				{(isNotEmpty(props, 'image')) && (
					<div class="main_media_flex header_img">
						<img src={props.image} class="full_screen_img" alt="" />
					</div>
				)}

				{props.children}
			</div>
		</FloatingLayerPublic>
	)
};

const AgeRestriction = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const [ date, setDate ] = useState(null);
	const [ error, setError ] = useState(false);

	const age_restriction = props.promotion?.config?.age_restriction ?? {};

	const image = age_restriction?.full_image ?? null;
	const min_age = parseInt(age_restriction?.age ?? '13');
	const max_age = parseInt(age_restriction?.max_age ?? '200');

	let text = age_restriction?.text ?? "";
	if(text == "") text = `<h1>${i18n("You must be over legal age")}</h1><p>${i18n("Please enter your birth date to continue")}</p>`;

	const enter_age = () => {
		if(date?.year == undefined) return;
		const iso = `${date.year}-${date.month}-${date.day}`;
		const moment_date = EPDate(iso);
		
		if(!EPDateIsValid(moment_date)) {
			setError(i18n('This date is not valid.'))
			return;
		}

		const age = EPDateDiff(null, moment_date, 'years');

		if(age < parseInt(age_restriction.age)) {
			setError('under_age');
			return;
		}
		if(age > parseInt(age_restriction.max_age)) {
			setError('too_old');
			return;
		}

		if(props.onAgeSelected != undefined) props.onAgeSelected(iso);
	};

	const wrapper_props = {
		promotion:props.promotion,
		image,
		is_builder:props.is_builder,
	};

	if(error == 'under_age') {
		return (
			<Wrapper
				{...wrapper_props}
			>
				<LeveledHTMLText>
					<h2>{i18n("You can not participate in this promotion")}</h2>

					<p>{i18n("You are under %s").replace('%s', age_restriction.age)}</p>
				</LeveledHTMLText>
			</Wrapper>
		)
	}

	if(error !== false) {
		return (
			<Wrapper
				{...wrapper_props}
			>
				<LeveledHTMLText>
					<h2>{i18n("You can not participate in this promotion")}</h2>
				</LeveledHTMLText>
			</Wrapper>
		)
	}

	return (
		<Wrapper
			{...wrapper_props}
		>
			<LeveledHTMLText>{text}</LeveledHTMLText>

			<div class="template_submodule ep_form gui_form">
				<DateWithSelector
					name="date"
					model={{
						date:(date != undefined) ? `${date.year}-${date.month}-${date.day}` : null,
					}}
					change={(k,v)=>setDate(v)}
					_class={{ first:true }}
					error_msg_position_class="mod_align_left"
					min_year={EPGetDateYear() - 100}
					max_year={EPGetDateYear() - 1}
				/>
			</div>

			<div class="submit_action" style={{ marginBlockStart:'3em' }}>
				<div class="flex_button gui_big_button">
					<ActionLink
						onClick={enter_age}
					>Continue</ActionLink>
				</div>
			</div>
		</Wrapper>
	);
}

export default injectIntl(AgeRestriction);